import http from './http.service';

class SigningService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/signing";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/get/${id}`);
    }

    create(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/create`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    createFromTask(data, taskId) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/createFromTask/${taskId}`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    createFromCoordination(data, coordinationId) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/createFromCoordination/${coordinationId}`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    createFromOrganizationalDocuments(data) {
        if (!data) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/createFromOrganizationalDocuments`, data);
    }

    start(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/start/${id}`);
    }

    edit(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/edit`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .delete(`${this.baseUrl}/${id}`);
    }

    getHistory(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/history/${id}`);
    }

    getResult(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/result/${id}`);
    }

    archive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/archive/${id}`);
    }

    unarchive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/unarchive/${id}`);
    }

    cancel(data) {
        if (!data) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/cancel`, data);
    }

    getAttachments(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getAttachments/${id}`);
    }

    saveSignedAttachment(model) {
        if (!model) {
            throw new Error('Model is required');
        }
        return this.$http.post(`${this.baseUrl}/saveSignedAttachment`, model);
    }

    complete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/complete/${id}`);
    }

    fileAttachment(model) {
        if (!model) {
            throw new Error('Model is required');
        }
        return this.$http.post(`${this.baseUrl}/fileAttachment`, model);
    }
}

export default new SigningService();
